import { updateAddOnsStep } from '../../../actions/add-ons';

const submitAddItemsForm = (values, dispatch, props) => {
  const { payload, isHostUpdate, isEditOffer } = props;
  analyticsIntegrations.customOfferStepCompleted(payload.data, 'add_ons', isEditOffer, isHostUpdate);

  dispatch(updateAddOnsStep(3));
};

export default submitAddItemsForm;
